import { render, staticRenderFns } from "./signinConfirmation.vue?vue&type=template&id=2088e5c7&"
import script from "./signinConfirmation.vue?vue&type=script&lang=js&"
export * from "./signinConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports